/*
 * n8n-Workflow-Vorschau mit Zwei-Klick-Lösung (Section `n8n-workflow-preview`).
 *
 * Vor dem Klick: nur ein statisches Bild aus dem Shop, kein Skript von n8n, kein iframe,
 * keine Daten an Dritte. Erst der Klick auf den Button
 *   1. lädt das Workflow-JSON (Theme-Asset, eigene Domain),
 *   2. lädt die selbst gehostete Komponente `n8n-demo` 1.0.20 (Theme-Asset, eigene Domain),
 *   3. setzt `<n8n-demo>` ein; die Komponente bettet die n8n-Seite
 *      https://n8n-preview-service.internal.n8n.cloud/workflows/demo als iframe ein
 *      und übergibt ihr das Workflow-JSON per postMessage.
 * Meldet der Dienst einen Fehler oder antwortet er nicht, bleibt das Bild stehen.
 */
(function () {
  'use strict';

  var PREVIEW_ORIGIN = 'https://n8n-preview-service.internal.n8n.cloud';
  var READY_TIMEOUT_MS = 20000;
  var RESEND_DELAYS_MS = [1200, 2400];
  var SWAP_DELAY_MS = 3500;
  var componentPromise = null;

  function loadComponent(src) {
    if (!componentPromise) {
      componentPromise = window.customElements && window.customElements.get('n8n-demo')
        ? Promise.resolve()
        : new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.type = 'module';
            script.src = src;
            script.onload = function () { resolve(); };
            script.onerror = function () { componentPromise = null; reject(new Error('component')); };
            document.head.appendChild(script);
          }).then(function () { return window.customElements.whenDefined('n8n-demo'); });
    }
    return componentPromise;
  }

  function loadWorkflow(url) {
    return fetch(url, { credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('workflow ' + response.status);
      return response.text();
    }).then(function (text) {
      var parsed = JSON.parse(text);
      if (!parsed || !Array.isArray(parsed.nodes)) throw new Error('workflow shape');
      return JSON.stringify(parsed);
    });
  }

  function setState(root, state) {
    root.setAttribute('data-state', state);
    var button = root.querySelector('[data-n8n-wp-load]');
    if (button) {
      button.disabled = state === 'loading';
      button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    }
  }

  function fail(root) {
    var frame = root.querySelector('[data-n8n-wp-frame]');
    if (frame) {
      frame.innerHTML = '';
      frame.hidden = true;
    }
    root.querySelector('[data-n8n-wp-static]').hidden = false;
    root.querySelector('[data-n8n-wp-consent]').hidden = true;
    root.querySelector('[data-n8n-wp-error]').hidden = false;
    setState(root, 'error');
  }

  function start(root) {
    if (root.getAttribute('data-state') === 'loading' || root.getAttribute('data-state') === 'ready') return;
    setState(root, 'loading');

    Promise.all([
      loadWorkflow(root.getAttribute('data-workflow-url')),
      loadComponent(root.getAttribute('data-component-url'))
    ]).then(function (results) {
      var frame = root.querySelector('[data-n8n-wp-frame]');
      var demo = document.createElement('n8n-demo');
      demo.setAttribute('workflow', results[0]);
      demo.setAttribute('frame', 'false');
      demo.setAttribute('clicktointeract', 'true');
      demo.setAttribute('collapseformobile', 'false');
      demo.setAttribute('hidecanvaserrors', 'true');
      demo.setAttribute('theme', 'light');

      var ready = false;
      var timer = window.setTimeout(function () { if (!ready) cleanup(true); }, READY_TIMEOUT_MS);

      function cleanup(failed) {
        window.clearTimeout(timer);
        window.removeEventListener('message', onMessage);
        if (failed) fail(root);
      }

      function onMessage(event) {
        if (event.origin !== PREVIEW_ORIGIN) return;
        var iframe = demo.shadowRoot && demo.shadowRoot.getElementById('int_iframe');
        if (!iframe || event.source !== iframe.contentWindow) return;
        var data;
        try { data = JSON.parse(event.data); } catch (e) { return; }
        if (data.command === 'n8nReady') {
          // Die Komponente schickt den Workflow sofort nach n8nReady. Auf schweren Seiten ist die
          // n8n-App dann noch nicht bereit und verwirft ihn (leerer Canvas, im Theme beobachtet).
          // Deshalb wird der Workflow, solange das Bild ihn noch verdeckt, zweimal nachgereicht;
          // openWorkflow ersetzt den Inhalt, ein doppelter Empfang ist harmlos.
          ready = true;
          window.clearTimeout(timer);
          RESEND_DELAYS_MS.forEach(function (delay) {
            window.setTimeout(function () {
              if (root.getAttribute('data-state') === 'loading' && typeof demo.loadWorkflow === 'function') {
                demo.loadWorkflow();
              }
            }, delay);
          });
          window.setTimeout(function () {
            if (root.getAttribute('data-state') !== 'loading') return;
            root.querySelector('[data-n8n-wp-static]').hidden = true;
            root.querySelector('[data-n8n-wp-consent]').hidden = true;
            setState(root, 'ready');
          }, SWAP_DELAY_MS);
        } else if (data.command === 'error') {
          cleanup(true);
        }
      }

      window.addEventListener('message', onMessage);
      frame.hidden = false;
      frame.appendChild(demo);
    }).catch(function () {
      fail(root);
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-n8n-wp]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-n8n-wp-bound')) return;
      root.setAttribute('data-n8n-wp-bound', 'true');
      var button = root.querySelector('[data-n8n-wp-load]');
      if (button) button.addEventListener('click', function () { start(root); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
